import { useState, useEffect } from 'react';

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      name: 'Marcus Johnson',
      position: 'Facilities Manager',
      company: 'Tech Solutions Inc.',
      image: 'https://public.readdy.ai/ai/img_res/baa9730120093629cbe7468055b6fb3a.jpg',
      rating: 5,
      text: 'VE Goodies has transformed our office break room experience. The machines are always stocked with fresh, healthy options, and their service team is incredibly responsive. Our employees love the variety!'
    },
    {
      name: 'Sarah Chen',
      position: 'HR Director',
      company: 'Global Innovations',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20American%20business%20woman%20in%20contemporary%20office%20environment%20smiling%20warmly%2C%20corporate%20headshot%20with%20natural%20lighting%20and%20modern%20background%2C%20confident%20HR%20director%20portrait%20in%20business%20attire&width=400&height=400&seq=testimonial-sarah-302&orientation=squarish',
      rating: 5,
      text: 'We switched to VE Goodies six months ago and couldn\'t be happier. The healthy snack options align perfectly with our wellness program, and the installation was completely hassle-free. Highly recommend!'
    },
    {
      name: 'David Martinez',
      position: 'Operations Manager',
      company: 'Manufacturing Plus',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Hispanic%20Latino%20business%20man%20in%20industrial%20office%20setting%20smiling%20confidently%2C%20corporate%20headshot%20with%20natural%20lighting%20and%20clean%20background%2C%20successful%20operations%20manager%20portrait%20in%20business%20casual%20clothing&width=400&height=400&seq=testimonial-david-303&orientation=squarish',
      rating: 5,
      text: 'The 24/7 support is a game-changer for our facility. When we had a minor issue at 2 AM, their team responded immediately. The machines are reliable, and the product selection is excellent.'
    },
    {
      name: 'Jennifer Williams',
      position: 'Office Administrator',
      company: 'Creative Studios',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Caucasian%20White%20business%20woman%20with%20blonde%20hair%20in%20modern%20creative%20office%20smiling%20warmly%20at%20camera%2C%20corporate%20headshot%20with%20natural%20lighting%20and%20contemporary%20background%2C%20friendly%20office%20administrator%20portrait&width=400&height=400&seq=testimonial-jennifer-304&orientation=squarish',
      rating: 5,
      text: 'VE Goodies made the entire process so easy. From consultation to installation, everything was professional and efficient. Our team loves having access to quality snacks and drinks throughout the day.'
    },
    {
      name: 'Raj Patel',
      position: 'CEO',
      company: 'StartUp Hub',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Indian%20American%20South%20Asian%20business%20executive%20in%20modern%20tech%20office%20smiling%20confidently%2C%20corporate%20CEO%20headshot%20with%20natural%20lighting%20and%20sleek%20background%2C%20successful%20entrepreneur%20portrait%20in%20business%20attire&width=400&height=400&seq=testimonial-raj-305&orientation=squarish',
      rating: 5,
      text: 'As a growing startup, we needed a vending solution that could scale with us. VE Goodies delivered exactly that. The custom branding option was a nice touch that our team really appreciates.'
    },
    {
      name: 'Amanda Thompson',
      position: 'Wellness Coordinator',
      company: 'Healthcare Partners',
      image: 'https://readdy.ai/api/search-image?query=Professional%20African%20American%20Black%20business%20woman%20in%20healthcare%20office%20setting%20smiling%20warmly%2C%20corporate%20headshot%20with%20natural%20lighting%20and%20clean%20background%2C%20confident%20wellness%20coordinator%20portrait%20in%20professional%20attire&width=400&height=400&seq=testimonial-amanda-306&orientation=squarish',
      rating: 5,
      text: 'The healthy options VE Goodies provides align perfectly with our healthcare mission. Their team worked with us to curate a selection that meets our nutritional standards. Outstanding service!'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 6000);

    return () => clearInterval(interval);
  }, []);

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonials" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-sm font-semibold text-orange-600 tracking-widest uppercase mb-4 block">
            Testimonials
          </span>
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            What Our Clients Say
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Don't just take our word for it - hear from businesses across DFW who trust VE Goodies
          </p>
        </div>

        <div className="relative max-w-5xl mx-auto">
          <div className="overflow-hidden rounded-3xl bg-white shadow-2xl">
            <div className="relative min-h-96 p-12 md:p-16">
              {testimonials.map((testimonial, index) => (
                <div
                  key={index}
                  className={`absolute inset-0 p-12 md:p-16 transition-opacity duration-500 ${
                    index === currentIndex ? 'opacity-100' : 'opacity-0 pointer-events-none'
                  }`}
                >
                  <div className="flex flex-col items-center text-center">
                    <div className="w-24 h-24 rounded-full overflow-hidden mb-6 shadow-lg">
                      <img
                        src={testimonial.image}
                        alt={testimonial.name}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>

                    <div className="flex items-center justify-center mb-6">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <div key={i} className="w-6 h-6 flex items-center justify-center">
                          <i className="ri-star-fill text-orange-500 text-xl"></i>
                        </div>
                      ))}
                    </div>

                    <p className="text-xl text-gray-700 leading-relaxed mb-8 max-w-3xl italic">
                      "{testimonial.text}"
                    </p>

                    <div>
                      <h4 className="text-xl font-bold text-gray-900 mb-1">{testimonial.name}</h4>
                      <p className="text-sm text-gray-600">
                        {testimonial.position} at <strong>{testimonial.company}</strong>
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg hover:bg-orange-500 hover:text-white transition-all cursor-pointer"
            aria-label="Previous testimonial"
          >
            <i className="ri-arrow-left-s-line text-2xl"></i>
          </button>

          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg hover:bg-orange-500 hover:text-white transition-all cursor-pointer"
            aria-label="Next testimonial"
          >
            <i className="ri-arrow-right-s-line text-2xl"></i>
          </button>

          <div className="flex items-center justify-center mt-8 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${
                  index === currentIndex ? 'bg-orange-500 w-8' : 'bg-gray-300 hover:bg-orange-300'
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              ></button>
            ))}
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
            <div className="text-5xl font-bold text-orange-600 mb-2">98%</div>
            <div className="text-sm font-semibold text-gray-700">Client Satisfaction</div>
          </div>
          <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
            <div className="text-5xl font-bold text-orange-600 mb-2">4.9/5</div>
            <div className="text-sm font-semibold text-gray-700">Average Rating</div>
          </div>
          <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
            <div className="text-5xl font-bold text-orange-600 mb-2">250+</div>
            <div className="text-sm font-semibold text-gray-700">Happy Clients</div>
          </div>
        </div>
      </div>
    </section>
  );
}
